import React from "react";
import ConnectSuccess from "../../partners/stripe/ConnectSucess";
import ConnectRefresh from "../../partners/stripe/ConnectRefresh";

export default function StripeConnect({isSuccess}) {
  
  return (
    <>
        {isSuccess ? <ConnectSuccess /> : <ConnectRefresh />}
      
    </>
  );
}